import React, { useEffect, useState } from 'react';
import { Carousel, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export default function Slider() {
  const [revendaData, setRevendaData] = useState(null);

  useEffect(() => {
    const auth = JSON.parse(JSON.parse(localStorage.getItem('persist:morelli')).parceiro).cnpjRevenda;
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const fetchUser = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/revendas/cnpj/${auth}`, {
          method: 'GET',
        });
        const data = await response.json();
        setRevendaData(data);
      } catch (error) {
        console.error('Erro ao buscar dados do usuário:', error);
      }
    };
    fetchUser();
  }, []);

  const handlePixBannerClick = (e) => {
    e.preventDefault();
    setTimeout(() => {
      window.scrollTo({
        top: 580,
        behavior: 'smooth'
      });
    }, 100);
  };

  return (
    <Container fluid="md" className="mb-5">
      <Row>
        <div className="d-none d-sm-block">
          <Carousel interval={3000}>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="imagens/Clube-Morelli---Grampo-Ponta-Bola_banner_1280x400.png"
                    alt="Banner Grampo Ponta Bola"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="imagens/Clube-Morelli---Grampo-Ponta-Bola_banner_1280x400.png"
                    alt="Banner Grampo Ponta Bola"
                  />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-distalizador1.png"
                    alt="Banner Distalizador"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-distalizador1.png"
                    alt="Banner Distalizador"
                  />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-orto-2.jpg"
                    alt="Banner Orto"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-orto-2.jpg"
                    alt="Banner Orto"
                  />
                </Link>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
        <div className="d-sm-none">
          <Carousel indicators={false} interval={3000}>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="imagens/Clube-Morelli---Grampo-Ponta-Bola_banner_1280x400.png"
                    alt="Banner Grampo Ponta Bola"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="imagens/Clube-Morelli---Grampo-Ponta-Bola_banner_1280x400.png"
                    alt="Banner Grampo Ponta Bola"
                  />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-distalizador1.png"
                    alt="Banner Distalizador"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-distalizador1.png"
                    alt="Banner Distalizador"
                  />
                </Link>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="d-none d-md-flex">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-orto-2.jpg"
                    alt="Banner Orto"
                  />
                </Link>
              </div>
              <div className="d-flex d-md-none">
                <Link to="/loja" onClick={(e) => e.preventDefault()}>
                  <img
                    className="d-block w-100"
                    src="banner/banner-orto-2.jpg"
                    alt="Banner Orto"
                  />
                </Link>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
      </Row>
    </Container>
  );
}
